import Permissions from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './MenuWrapper'
import { MenuLinkWrapper } from './MenuWrapper'

const CO2eCalculatorLink: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.co2eCalculator,
    permission: [Permissions.TRANSPARENCY_USER],
  }

  return (
    <MenuLinkWrapper
      icon={icon}
      external
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.co2eCalculator' })}
    />
  )
}

export default CO2eCalculatorLink
